module.exports = "../static/media/logo.254871e7.png";